import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_AMPLITUDE_SESSION_REPLAY_CONFIG = defineFcm('amplitude_session_replay_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				sampleRate: {
					type: 'number',
					normalizer: (v: number) => {
						if (v < 0 || v > 1) {
							throw new Error('Sample rate must be between 0 and 1');
						}
						return v;
					},
				},
				routes: {
					type: 'record',
					shape: {
						type: 'boolean',
					},
				},
			},
		}),
	)
	.withDefault({
		enabled: false,
		sampleRate: 0,
		routes: {},
	})
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'Amplitude Session Replay',
		description: `This configures how Amplitude Session Replay is enabled for different routes.

		"routes" is a map of route id => enabled

		The route id can be retrieved from https://www.staging-change.org/corgi/stats/routes.html

		The sample rate should be a number between 0 and 1, where 0 means no session replay and 1 means all sessions are recorded.

		If the user navigates to a route that is enabled, Session Replay will turn on. If they navigate to a route that is not enabled, Session Replay will turn off.`,
		import: false,
		template: {
			enabled: true,
			sampleRate: 0.5,
			routes: {
				homepage: true,
				'petition-details': true,
			},
		},
	});
